import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { Col, Form, Row } from 'react-bootstrap';
import DownloadLink from '../../../components/common/DownloadLink';
import useAPI from '../../../hooks/useAPI';
import ProgramBuysTableBuys from './ProgramBuysTableBuys';
import ProgramBuysTableKvrs from './ProgramBuysTableKvrs';
import { years } from '../../../helpers';
import { getDataURL, getExportFileName } from '../helpers/budgetReportHelper';
import LoadingTable from '../../../components/table/LoadingTable';

const OPTIONS_VIEW = {
  buys: { title: 'По закупкам', url: '/reports/budget/buys', fileName: 'Выгрузка по закупкам' },
  kvr: { title: 'По КВР', url: '/reports/budget/buys/byKvrs', fileName: 'Выгрузка по КВР' },
};

const OPTIONS_SOURCE = {
  fb: 'Грант',
  sf: 'Софинансирование',
};

export default function ProgramBuysList() {
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-undef
  const [selectedYear, setSelectedYear] = useState(2025);
  const [selectedView, setSelectedView] = useState('buys');
  const [selectedSource, setSelectedSource] = useState('fb');
  const [tableData, setTableData] = useState([]);
  const [problemsList, setProblemsList] = useState([]);
  const isNew = selectedYear >= 2025;

  const api = useAPI();

  const fetchData = async () => {
    setIsLoading(true);
    const dataURL = getDataURL(OPTIONS_VIEW[selectedView].url, { year: selectedYear, source: selectedSource });
    const response = await api.get(dataURL);
    if (response && !response.error) {
      setIsLoading(false);
      return response;
    }
    setIsLoading(false);
    return [];
  };

  useEffect(() => {
    const fetchTableData = async () => {
      const response = await fetchData();
      setTableData(response);
    };
    fetchTableData();
  }, [selectedYear, selectedView, selectedSource]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await api.get('/mng/buys/types/problems');
      setProblemsList(response);
    };
    fetchData();
  }, []);

  return (
    <>
      <Row className="mb-12">
        <Form.Group as={Col} md="2">
          <Form.Label>Отчетный год </Form.Label>
          <Form.Control
            required
            as="select"
            value={selectedYear}
            onChange={(e) => setSelectedYear((e.target.value))}
          >
            {years.map((year) => <option key={year} value={year}>{year}</option>)}
          </Form.Control>
          <Form.Control.Feedback type="invalid">Выберите год</Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} md="4">
          <Form.Label>
            Представление
          </Form.Label>
          <Form.Control
            required
            as="select"
            value={selectedView}
            onChange={(e) => setSelectedView(e.target.value)}
          >
            {Object.entries(OPTIONS_VIEW).map(([key, view]) => (
              <option key={key} value={key}>
                {view.title}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        {!isNew && (
          <Form.Group as={Col} md="4">
            <Form.Label>
              Тип финансирования
            </Form.Label>
            <Form.Control
              required
              as="select"
              value={selectedSource}
              onChange={(e) => setSelectedSource(e.target.value)}
            >
              {Object.entries(OPTIONS_SOURCE).map(([key, label]) => (
                <option key={key} value={key}>
                  {label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        )}
        <Form.Group as={Col}>
          <DownloadLink
            variant="primary"
            type="submit"
            url={getDataURL(OPTIONS_VIEW[selectedView].url, { year: selectedYear, source: selectedSource }, true)}
            filename={getExportFileName(`${OPTIONS_VIEW[selectedView].fileName} (${selectedSource === 'fb' ? 'грант' : 'СФ'})`)}
            style={{ marginTop: '30px' }}
          >
            Выгрузить в Excel
          </DownloadLink>
        </Form.Group>
      </Row>
      <Row>
        {
          selectedView === 'buys' &&
          <LoadingTable spinnerStyle={{marginTop: '30px'}} loadingObject={{isLoading}}>
            <ProgramBuysTableBuys
              data={tableData}
              sourceType={selectedSource}
              reportType="onSecy"
              ctx={{ problemTypes: problemsList }}
              updateRow={(id, newRow) => setTableData((prev) => prev.map((r) => (r.id === id ? Object.assign(r, newRow) : r)))}
              year={selectedYear}
            />
          </LoadingTable>
        }
        {
          selectedView === 'kvr' && !isLoading && (
            <ProgramBuysTableKvrs data={tableData} sourceType={selectedSource} reportType="onSecy" />
          )
        }
      </Row>
    </>
  );
}
